import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'transaction-update-form',
    templateUrl: './transaction-update-form.component.html',
    styleUrls: ['./transaction-update-form.component.css']
})

export class TransactionUpdateFormComponent implements OnChanges {

    @Input() public transactionHistory: any;

    constructor() {

     }

    ngOnChanges() {

    }


}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/transaction-update-form/transaction-update-form.component.ts